<template>
  <a-link
    v-if="!hideCategory"
    :to="linkToCategoryPage"
    :trailing-slash="!isMigratedCategory"
    class="category-label-link text-medium bold"
  >
    {{ category.name }}
  </a-link>
</template>

<script>
import { ROUTE_NAME } from 'enums/routes'
import {
  findMigratedCategorySlug,
  MIGRATED_CATEGORY_SLUG
} from 'enums/categories'
import { PROP_TYPES, propValidator } from '@fmpedia/validators'
import mixins from '@/utils/mixins'

export default {
  name: 'ACategoryLabelLink',
  mixins: [mixins.urlGenerators],
  props: {
    category: propValidator([PROP_TYPES.OBJECT], false),
    hideCategory: propValidator([PROP_TYPES.BOOLEAN], false, false)
  },
  computed: {
    isNewsCategory() {
      return (
        this.category.slug.toLowerCase() ===
        MIGRATED_CATEGORY_SLUG.NEWS.toLowerCase()
      )
    },
    linkToCategoryPage() {
      return this.isNewsCategory
        ? { name: ROUTE_NAME.HOMEPAGE }
        : this.generateCategoryPath(this.category)
    },
    isMigratedCategory() {
      if (!this.category || this.isNewsCategory) return false
      const { slug } = this.$helper.processResponse(this.category)
      return findMigratedCategorySlug(slug)
    }
  }
}
</script>

<style lang="scss" scoped>
.category-label-link {
  @include categoryLink;
}
</style>
